import * as types from "@/store/types";

const state = {
  subscribePlans: [],
  calculatorPlans: []
};

const applyPlansMutation = (state, key, payload, append) => {
  if (append) {
    state[key].push(...payload);
  } else {
    state[key] = payload;
  }
};

const getters = {
  [types.staking.getters.GET_SUBSCRIBE_PLANS]: state => {
    return state.subscribePlans;
  },
  [types.staking.getters.GET_CALCULATOR_PLANS]: state => {
    return state.calculatorPlans;
  }
};

const mutations = {
  [types.staking.mutations.MUTATE_SUBSCRIBE_PLANS]: (
    state,
    { payload, append }
  ) => applyPlansMutation(state, "subscribePlans", payload, append),
  [types.staking.mutations.MUTATE_CALCULATOR_PLANS]: (
    state,
    { payload, append }
  ) => applyPlansMutation(state, "calculatorPlans", payload, append)
};

const actions = {
  [types.staking.actions.SET_SUBSCRIBE_PLANS]: ({ commit }, payload) => {
    commit(types.staking.mutations.MUTATE_SUBSCRIBE_PLANS, payload);
  },
  [types.staking.actions.SET_CALCULATOR_PLANS]: ({ commit }, payload) => {
    commit(types.staking.mutations.MUTATE_CALCULATOR_PLANS, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
